import { z } from "zod";
import { MAX_LEN_WEB_S, MIN_LEN_S } from "../constants";

export const startMsSchema = z.number().int().min(0).max(Number.MAX_SAFE_INTEGER);

export const lengthSSchema = z.number().min(MIN_LEN_S).max(MAX_LEN_WEB_S);

export const regionUpdateSchema = z.object({
  start_ms: startMsSchema,
  length_s: lengthSSchema,
});
